import { makeStyles } from '@material-ui/core/styles';

const useStyle = makeStyles((theme) => ({
  dialogTitle: {
    fontSize: 16,
    textTransform: 'uppercase',
  },
  isInDueTime: {
    backgroundColor: '#fff',
    color: '#4caf50',
    borderRadius: 4,
    fontWeight: 600,
    fontSize: 13,
    textTransform: 'uppercase',
  },
  isntInDueTime: {
    backgroundColor: '#fff',
    color: '#f44336',
    borderRadius: 4,
    fontWeight: 600,
    fontSize: 13,
    textTransform: 'uppercase',
  },
  dueTime: {
    backgroundColor: '#cdebfa',
    color: '#1ca5e8',
    borderRadius: 4,
    fontWeight: 600,
    fontSize: 12,
    textTransform: 'uppercase',
  },
  general: {
    backgroundColor: '#eceff1',
    color: '#869ca6',
    borderRadius: 4,
    fontWeight: 600,
    fontSize: 12,
    textTransform: 'uppercase',
  },
  title: {
    fontWeight: 500,
    fontSize: 16,
  },
  description: {
    fontSize: 14,
  },
  money: {
    fontSize: 18,
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
  },
  dueDateToModeration: {
    marginTop: 20,
  },
  iconText: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  errorIcon: {
    color: '#dc3f53',
    fontSize: 28,
    marginRight: 8,
  },
  successIcon: {
    color: '#009358',
    fontSize: 28,
    marginRight: 8,
  },
}));

export default useStyle;
